import { lazyLoad } from 'utils/loadable';

export const CredentialingAttachmentsViewerLoadable = lazyLoad(
  () => import('./CredentialingAttachmentsViewer'),
  module => module.CredentialingAttachmentsViewer,
);
